import { format } from 'date-fns';
import { pl } from 'date-fns/locale';

export const PublicationDate = ({ date }) => {
  if (!date) return null;

  const parsedDate = new Date(date);

  if (Number.isNaN(parsedDate.getTime())) {
    return null;
  }

  const formattedDate = format(parsedDate, 'd MMMM yyyy', { locale: pl });

  return (
    <time
      dateTime={parsedDate.toISOString()}
      className="date mr-[6px] inline-flex border-r border-solid border-tertiary px-0 !pr-[6px] text-[12px] leading-[16px] text-tertiary"
    >
      {formattedDate}
    </time>
  );
};
